import React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import AssignmentIcon from "@mui/icons-material/Assignment";
import DescriptionIcon from "@mui/icons-material/Description";
import InventoryIcon from "@mui/icons-material/Inventory";
import ApartmentIcon from "@mui/icons-material/Apartment";
import GroupsIcon from "@mui/icons-material/Groups";
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';

const BRAND_RED = "#8B1A1A";

const ITEMS = [
  {
    link: "permission-types",
    text: "İzin Türleri",
    icon: <AssignmentIcon />,
  },
  {
    link: "documents",
    text: "Belgeler",
    icon: <DescriptionIcon />,
  },
  {
    link: "equipments",
    text: "Ekipmanlar",
    icon: <InventoryIcon />,
  },
  {
    link: "departments",
    text: "Departmanlar",
    icon: <ApartmentIcon />,
  },
  {
    link: "teams",
    text: "Takımlar",
    icon: <GroupsIcon />,
  },
  {
    link: "used-equipments",
    text: "Kullanılan Ekipmanlar",
    icon: <BusinessCenterIcon />,
  },
];

const ApplicationManagement = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "75vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
        py: { xs: 4, md: 8 },
      }}
    >
      <Typography
        variant="h4"
        sx={{
          mb: 6,
          fontWeight: 700,
          color: BRAND_RED,
          letterSpacing: 1,
          textAlign: "center"
        }}
      >
        Uygulama Yönetimi
      </Typography>

      <Grid 
        container 
        spacing={4} 
        justifyContent="center" 
        maxWidth={1000} 
        sx={{ px: 2 }}
      >
        {ITEMS.map((item) => (
          <Grid 
            item 
            xs={12} 
            sm={6} 
            md={4} 
            key={item.link}
            sx={{ display: "flex", justifyContent: "center" }} // Grid item içinde merkeze al
          >
            <Card
              sx={{
                width: 240,   // Sabit Genişlik
                height: 180,  // Sabit Yükseklik
                bgcolor: "#fff",
                borderRadius: 4,
                border: "1px solid rgba(139, 26, 26, 0.15)",
                boxShadow: "0 4px 15px rgba(0,0,0,0.06)",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow: "0 12px 30px rgba(139, 26, 26, 0.18)",
                  borderColor: BRAND_RED,
                  "& .icon-box": {
                    bgcolor: BRAND_RED,
                    color: "#fff",
                    transform: "scale(1.1)"
                  }
                },
              }}
              onClick={() => navigate(item.link)}
            >
              <CardActionArea
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  p: 3,
                }}
              >
                <Box 
                  className="icon-box"
                  sx={{ 
                    mb: 2.5, 
                    width: 64,
                    height: 64,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "rgba(139, 26, 26, 0.04)",
                    color: BRAND_RED,
                    borderRadius: "16px", // Karemsi yuvarlak ikon kutusu
                    transition: "all 0.3s ease",
                  }}
                >
                  {React.cloneElement(item.icon, { sx: { fontSize: 32 } })}
                </Box>
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: 600,
                    color: "#333",
                    textAlign: "center",
                    lineHeight: 1.2,
                  }}
                >
                  {item.text}
                </Typography>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ApplicationManagement;



